import PropTypes from 'prop-types';

import Text from './Text';
import Radio from './Radio';
import Checkbox from './Checkbox';

const INPUT_TYPES = [
  'text',
  'password',
  'email',
  'checkbox',
  'radio',
  'submit',
  'tel',
  'hidden',
];

const renderInputType = (props) => {
  switch (props.type) {
    case 'text':
      return <Text {...props} />;
    case 'password':
      return <Text {...props} />;
    case 'email':
      return <Text {...props} />;
    case 'checkbox':
      return <Checkbox {...props} />;
    case 'radio':
      return <Radio {...props} />;
    case 'hidden':
      return <input type="hidden" {...props.input} />;
    default:
      return <Text {...props} />;
  }
};

renderInputType.propTypes = {
  type: PropTypes.oneOf(INPUT_TYPES).isRequired,
  input: PropTypes.object.isRequired, // eslint-disable-line
};

export default renderInputType;
